// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"6c0548fe","487":"401e83c7"}[chunkId] + ".chunk.js";
};